import React, { Component } from 'react';

class List extends Component{
	render(){
		let className = 'list-flex';
		className = !this.props.className ? className : className + ' ' + this.props.className;
		return (
			<div className={className}>
					{this.props.items}
			</div>
		);
	}
}

export default List;


// WEBPACK FOOTER //
// ./src/components/common/List.js